<template>
  <div class="zsd-container">
    <van-question-steam :exercise="exercise" />
    <div class="bq-wrap">
      <span :class="{ answer: exercise.isHollow }"
            v-for="(exercise, index) in mExercise"
            :key="index"
            v-html="exercise.text">
      </span>
    </div>
  </div>
</template>

<script>
// import utils from '@/services/utils';
import VanQuestionSteam from '@/components/common/QuestionSteam.vue';

const PICK_ANSWER = /(\[\[[^\]]*]])/; // 包含符号
// const PICK_ANSWER2 = /(?<=\[\[)[^\]]*(?=]])/g; // 不包含符号 只匹配一个

export default {
  props: {
    exercise: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    VanQuestionSteam,
  },
  data() {
    return {
      mExercise: [],
    };
  },
  watch: {
    exercise: {
      handler() {
        // format data
        this.formatExercise();
      },
      immediate: true,
    },
  },
  methods: {
    formatExercise() {
      if (!this.exercise.text) {
        /* eslint-disable no-throw-literal */
        throw 'exercise text is null';
      }
      this.exercise.text = this.exercise.text.replace(/\n/g, '<br />');
      this.mExercise = this.exercise.text.split(PICK_ANSWER).map((item) => {
        const isHollow = PICK_ANSWER.test(item);
        const knowledgePoint = item.replace(/#\d+#/g, '').replace(/(\[|\])/g, '').split('||')[0].replace(/^@/, '');
        return isHollow ? {
          isHollow: true,
          text: knowledgePoint,
        } : { isHollow: false, text: item };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .zsd-container {
    padding: 0 20px;
    .bq-wrap {
      font-size: 18px;
      line-height: 2.4;
      margin-top: 20px;
      /deep/ .interval {
        display: block;
        width: 10px;
        height: 10px;
      }
      .answer {
        font-weight: bold;
        border-bottom: 2px solid #606266;
      }
    }
  }
</style>
